import React from "react";

const AsciiDivider = ({ char = "─", className = "" }) => {
  return (
    <div className={`ascii-divider ${className}`} aria-hidden="true">
      {char.repeat(120)}
    </div>
  );
};

export default AsciiDivider;
